import { isMobile } from '@pascal/pascal-core';
import { webConfig } from '../core/pixi/config';

export const getScreenResolution = () => {
  const { innerWidth, innerHeight } = window;
  let width = innerWidth;
  let height;
  switch (true) {
    case isMobile():
      height = (width * 16) / 9;
      return {
        height: 0,
        width: 0,
        transform: `scale(${(width * 5) / webConfig.width})`,
      };
    case !isMobile():
    default:
      height = (width * 9) / 16;
      if (height > innerHeight) {
        height = innerHeight;
        width = (height * 16) / 9;
      }
      return {
        height,
        width,
      };
  }
};
